import UploaderFile from './uploader-file.js';

interface FileInfo {
  file?: UploaderFile;
}

export default FileInfo;
